export default "__VITE_ASSET__D4ChUNVg__"